import React, { useState } from 'react';
import { noticesMock } from './mockData';

import Header from './Header';
import { API_BASE_URL,NoticesAddAPIEndpoint, NoticesGetAPIEndpoint, NoticesUpdateAPIEndpoint, NoticesDeleteAPIEndpoint  } from '../constant';
import { useEffect } from 'react';
import "./css/paginationtable.css";

function Notices() {
  const [notices, setNotices] = useState([]);
  const [form, setForm] = useState({ title: "", description: "" });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);


    const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 3; 

  const indexOfLast = currentPage * recordsPerPage;
const indexOfFirst = indexOfLast - recordsPerPage;

const currentRecords = notices.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(notices.length / recordsPerPage);

const userType = sessionStorage.getItem("userType"); // or session
const isUserTypeAdmin = userType === "admin" ? true : false;
const token = sessionStorage.getItem("JWTtoken");

  const fetchNotices = async () => {
      try {
        const apiURL = API_BASE_URL + NoticesGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.status) {
          setNotices(data.data);
        } else {
          setError(data.message || "Failed to fetch notices");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };




    useEffect(() => {  
    fetchNotices();
  }, []);



 const validate = () => {

  // Validation: Name, phone, and apartment must not be empty
    if (!form.title.trim() || !form.description.trim()) {
      alert("Title and Description are required!");
      return; // Stop submission
    }
    return true;
 }



  const handleSubmit = async (e)  => {

    e.preventDefault();

    if (!validate()) return;

    if (editingId) {
      setNotices(notices.map(n => n.id === editingId ? { ...form, id: editingId } : n));
      setEditingId(null);


try {
        const updateApiURL = API_BASE_URL + NoticesUpdateAPIEndpoint;
        const payload = {
          ...form,                 // existing form fields
          id: editingId
        };


    const response = await fetch(updateApiURL,
      {
        method: "POST",
        headers: { 
          "Content-Type": "application/json", 
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();

    if (result.status) {
      alert("Notice updated successfully");

      // 🔥 reload table with updated data
      fetchNotices();

      //setEditForm(null);
    } else {
      alert(result.message);
    }
  } catch (err) {
    alert("Server error");
  }


    } else {
      // const token = sessionStorage.getItem("JWTtoken");
      //setNotices([...notices, { ...form, id: Date.now() }]);
      try {
      //setUsers([...users, { ...form, id: Date.now() }]);
      const addApiURL = API_BASE_URL + NoticesAddAPIEndpoint;
      
      const response = await fetch(addApiURL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(form)
      }
    );

    const result = await response.json();
      if (result.status) 
      {
          alert("Notice added successfully.");
          setForm({
            title: "",
            description: ""
          });
          fetchNotices(); // Refresh the notices list
      } 
      else 
      {
        alert(result.message);      
      }
    } 
    catch (error) 
    {
      alert("Server error".error);
    } 
  
  }
    setForm({ title: "", description: "" });
  };

  const handleEdit = (n) => {
    setForm({ title: n.title, description: n.description });
    setEditingId(n.id);
  };

  const handleDelete = async (noticeId) => 
    {
      //setNotices(notices.filter(n => n.id !== noticeId));
      try {
        const deleteApiURL = API_BASE_URL + NoticesDeleteAPIEndpoint;
        const confirmed = window.confirm(
          "Are you sure you want to delete this record?"
        );

        if (!confirmed) {
          return;
        }
        const payload = { id : noticeId}; 
        const response = await  fetch(deleteApiURL,
          {
            method: "Delete",
             headers: { 
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
           },
            body: JSON.stringify(payload)
          }
        );
        const result = await response.json();
        

        if (result.status) {
          alert("Notice deleted successfully");
          await fetchNotices(); // Refresh the notices list
//           const loadNotices = async () => {
//   const response = await fetchNotices(); 
// };
        } else {
          alert(result.message);
        }
      }
      catch (error) {
        alert("Server error".error);
      }
    };

  return ( <>
  <Header/>
    <div>
      <h1>Notices</h1>
      {
        isUserTypeAdmin && <div> <input placeholder="Title" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}/>
      <input placeholder="Description" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}/>
      <button onClick={handleSubmit}>{editingId ? "Update" : "Add"} Notice</button></div>
      }
       <div className="table-container">
      <table style={{ border:"1px solid", width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "burlywood" }}>
            <th>Title</th>
            <th>Description</th>
            {isUserTypeAdmin && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {
          currentRecords.length > 0 ? (
            currentRecords.map( (n, index) => {
            return (<tr  key={n.id} className={index % 2 === 0 ? "even" : "odd" } >
              <td>{n.title}</td>
              <td>{n.description}</td>
              {isUserTypeAdmin && <td><button onClick={() => handleEdit(n)}>Edit</button> <button onClick={() => handleDelete(n.id)}>Delete</button></td>}
            </tr>
)})) : (
            <tr>
              <td colSpan="5" align="center">No records found</td>
            </tr>
          )
          
        }
        </tbody>
      </table>
          </div>
       <div style={{ marginTop: "10px" }}>
    <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}> Prev 
  </button>

  {[...Array(totalPages)].map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      style={{
        fontWeight: currentPage === i + 1 ? "bold" : "normal",
        margin: "0 5px"
      }}
    >
      {i + 1}
    </button>
  ))}

  <button
    onClick={() =>
      setCurrentPage(prev => Math.min(prev + 1, totalPages))
    }
    disabled={currentPage === totalPages}
  >
    Next
  </button> {indexOfFirst + 1} to {notices.length < indexOfLast ? notices.length : indexOfLast} of Total Record {notices.length} 
</div>
    </div>

    {/*<Pagination recordCount={notices.length} currentWorkingPage={currentPage} setCurrentWorkingPage={currentPage}  />*/}


    </>
  );
}

export default Notices;
